import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { CardBasic } from "extranet-component-library";
import boletoB from "../assets/img/cards/boletoB.svg";
import warning from "../assets/img/warning.svg";
import { useStores } from "../hooks/useStores";
import { getNextDiscount } from "../utils/parsers";
import NextPrices from "../components/NextPrices";
import NextHours from "../components/NextHours";

const NextTravel = observer(() => {
  const { t } = useTranslation();
  const { myTimStore, myTibStore, nextTravelStore } = useStores();
  const { walletOperations, card } = myTimStore;
  const { nextHours } = myTibStore;
  const { cardProfileId, nextTravel, bonusesResident } = nextTravelStore;
  const [travels, setTravels] = useState<Array<any>>(nextTravel);

  useEffect(() => {
    if (card && card.tim && travels.length === 0) {
      nextTravelStore.calculateNextTravel(card.tim);
    }
    parseTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [card.tim, nextTravel.length]);

  useEffect(() => {
    if (cardProfileId) {
      nextTravelStore.getBonusesResident(cardProfileId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardProfileId]);

  const parseTable = () => {
    const parsed = nextTravel.map((travel: any) => {
      return {
        ...travel,
        hops: `${travel.hops} ${t("card.hops")}`,
        price: `${travel.price} €`,
      };
    });
    setTravels(parsed);
  };

  return (
    <>
      <div className="page-title-mobile">
        {t("next_travel").replace("/", " ")}
        <img src={boletoB} alt="img" />
      </div>
      <div className="next-travel">
        <CardBasic
          content={
            <div className="flex-container justify-start">
              {walletOperations && walletOperations.length > 0 ? (
                <div className="nt-items">
                  <div className="border">
                    <div className="item">
                      <span className="light-text">
                        {t("next_travel_date")}
                      </span>
                      <br />
                      <span className="bold-text">
                        {walletOperations[0].operationDate}
                      </span>
                    </div>
                  </div>
                  <div className="border">
                    <div className="item">
                      <span className="light-text">
                        {t("headers.totalPoints")}
                      </span>
                      <br />
                      <span className="bold-text">
                        {walletOperations[0].totalPoints}
                      </span>
                    </div>
                  </div>
                  <div className="border">
                    <div className="item">
                      <span className="light-text">
                        {t("discount_next_travel")}
                        <div className="tooltip">
                          <img src={warning} alt="icon" />
                          <span
                            className="text p-link"
                            style={{ width: "auto" }}
                          >
                            {t("tooltip")}
                          </span>
                        </div>
                      </span>
                      <br />
                      <span className="bold-text" data-testid="discount">
                        {getNextDiscount(
                          walletOperations[0].totalPoints,
                          bonusesResident
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          }
        />
      </div>

      <div className="flex-column">
        <NextPrices travels={travels} />
        <NextHours nextHours={nextHours} />
      </div>
    </>
  );
});

export default NextTravel;
